// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BubbleChart.css */

.bubble-chart-root {
  width: 100%;
  border: 1px solid #e5e9ec;
  border-radius: 8px;
  background-color: #ffffff;
  box-sizing: border-box;
}

.bubble-chart-content {
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.bubble-title {
  color: #061522;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  margin: 0 0 8px 0;
}

.bubble-description {
  color: #405261;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin: 0 0 11px 0;
}

.bubble-container {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  box-sizing: border-box;
}

.bubbleChart {
  position: absolute;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  transform: translate(-50%, -50%);
}

.bubble-label-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 85%;
  max-height: 85%;
  padding: 4px;
  overflow: hidden;
}

.bubble-label {
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
  width: 100%;
}

.bubble-tooltip {
  position: fixed;
  pointer-events: none;
  z-index: 1300;
  border: 1px solid #d5dce1;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 15px 20px rgba(6, 21, 34, 0.05);
  padding: 16px;
  min-width: 168px;
}

.bubble-tooltip-title {
  color: #061522;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  margin: 0 0 16px 0;
}

.bubble-tooltip-name {
  color: #405261;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin: 0 0 8px 0;
}

.bubble-tooltip-usage {
  color: #061522;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.loading-skeleton {
  border-radius: 50%;
  background-color: #f0f2f5;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(0.95);
  }
  50% {
    opacity: 0.8;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/Analytics/KnowledgeBase/styles.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":["/* BubbleChart.css */\n\n.bubble-chart-root {\n  width: 100%;\n  border: 1px solid #e5e9ec;\n  border-radius: 8px;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n\n.bubble-chart-content {\n  padding: 24px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.bubble-title {\n  color: #061522;\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 18px;\n  margin: 0 0 8px 0;\n}\n\n.bubble-description {\n  color: #405261;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0 0 11px 0;\n}\n\n.bubble-container {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  overflow: hidden;\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.bubbleChart {\n  position: absolute;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  transform: translate(-50%, -50%);\n}\n\n.bubble-label-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 85%;\n  max-height: 85%;\n  padding: 4px;\n  overflow: hidden;\n}\n\n.bubble-label {\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  text-align: center;\n  line-height: 1.2;\n  width: 100%;\n}\n\n.bubble-tooltip {\n  position: fixed;\n  pointer-events: none;\n  z-index: 1300;\n  border: 1px solid #d5dce1;\n  border-radius: 8px;\n  background-color: #ffffff;\n  box-shadow: 0 15px 20px rgba(6, 21, 34, 0.05);\n  padding: 16px;\n  min-width: 168px;\n}\n\n.bubble-tooltip-title {\n  color: #061522;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 18px;\n  margin: 0 0 16px 0;\n}\n\n.bubble-tooltip-name {\n  color: #405261;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0 0 8px 0;\n}\n\n.bubble-tooltip-usage {\n  color: #061522;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  margin: 0;\n}\n\n.loading-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 20px;\n  background-color: rgba(255, 255, 255, 0.8);\n  z-index: 10;\n}\n\n.loading-skeleton {\n  border-radius: 50%;\n  background-color: #f0f2f5;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 0.4;\n    transform: scale(0.95);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
